import { ComponentPropsWithoutRef } from 'react';

export const FrameIcon = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 35 28" fill="none">
      <path
        d="M30.833 9V4h-5V.665h8.333v8.333h-3.333Zm-30 0V.665h8.333v3.333h-5v5H.833Zm25 18.333v-3.334h5v-5h3.333v8.334h-8.333Zm-25 0v-8.334h3.333v5h5v3.334H.833ZM7.5 20.666V7.333h20v13.333h-20Z"
        fill="#000000"
      />
    </svg>
  );
};
